const keyCodes = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ALT: 18,
  ESCAPE: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
})

export default keyCodes
